export default __webpack_public_path__ + "static/media/GBBC_logo.02f1bef5.png";